export const navLinks = [
  { label: '首页', href: '/' },
  { label: '分类浏览', href: '/category' },
  { label: '最新资讯', href: '/category?tab=articles' },
  { label: '关于我们', href: '/about' },
];

export const heroData = {
  headline: '高清流畅 随心观看',
  subheadline: '茄子视频 — 不缓冲、不卡顿，海量电视剧电影免费在线观看',
  ctaText: '立即观看',
  ctaLink: '/category',
  secondaryText: '了解更多',
  secondaryLink: '/about',
};

export interface HotItem {
  id: string;
  title: string;
  category: string;
  rating: number;
  episodes: number;
  imageUrl: string;
  tags: string[];
  link: string;
}

export const hotRecommendations: HotItem[] = [
  {
    id: 'rec-1', title: '繁花', category: '电视剧', rating: 9.2, episodes: 30,
    imageUrl: 'https://readdy.ai/api/search-image?query=Blossoms%20Shanghai%20TV%20drama%20poster%20with%20vintage%201990s%20Chinese%20cityscape%20warm%20golden%20lighting%20elegant%20composition%20cinematic%20style%20rich%20textures%20nostalgic%20atmosphere&width=600&height=800&seq=hot-rec-01&orientation=portrait',
    tags: ['热播', '推荐'], link: '/category?tab=电视剧',
  },
  {
    id: 'rec-2', title: '三体', category: '科幻剧', rating: 8.9, episodes: 30,
    imageUrl: 'https://readdy.ai/api/search-image?query=Three%20Body%20Problem%20sci-fi%20TV%20series%20poster%20cosmic%20background%20mysterious%20dark%20space%20with%20stars%20dramatic%20cinematic%20lighting%20futuristic%20elements%20deep%20blue%20and%20gold%20tones&width=600&height=800&seq=hot-rec-02&orientation=portrait',
    tags: ['热播'], link: '/category?tab=电视剧',
  },
  {
    id: 'rec-3', title: '狂飙', category: '刑侦剧', rating: 9.3, episodes: 39,
    imageUrl: 'https://readdy.ai/api/search-image?query=The%20Knockout%20Chinese%20crime%20drama%20poster%20intense%20atmosphere%20dark%20urban%20night%20scene%20suspenseful%20cinematic%20lighting%20strong%20contrast%20modern%20Chinese%20city%20background&width=600&height=800&seq=hot-rec-03&orientation=portrait',
    tags: ['热门', '高分'], link: '/category?tab=电视剧',
  },
  {
    id: 'rec-4', title: '庆余年第二季', category: '古装剧', rating: 8.7, episodes: 36,
    imageUrl: 'https://readdy.ai/api/search-image?query=Joy%20of%20Life%20Season%202%20ancient%20Chinese%20costume%20drama%20poster%20elegant%20traditional%20Chinese%20palace%20background%20warm%20amber%20lighting%20rich%20red%20and%20gold%20tones%20cinematic%20composition&width=600&height=800&seq=hot-rec-04&orientation=portrait',
    tags: ['热播', '新番'], link: '/category?tab=电视剧',
  },
  {
    id: 'rec-5', title: '漫长的季节', category: '悬疑剧', rating: 9.4, episodes: 12,
    imageUrl: 'https://readdy.ai/api/search-image?query=The%20Long%20Season%20Chinese%20mystery%20drama%20poster%20nostalgic%201990s%20northeast%20China%20industrial%20town%20autumn%20leaves%20warm%20but%20melancholy%20tone%20cinematic%20photography%20golden%20hour%20lighting&width=600&height=800&seq=hot-rec-05&orientation=portrait',
    tags: ['高分', '必看'], link: '/category?tab=电视剧',
  },
  {
    id: 'rec-6', title: '莲花楼', category: '武侠剧', rating: 8.8, episodes: 40,
    imageUrl: 'https://readdy.ai/api/search-image?query=Mysterious%20Lotus%20Casebook%20Chinese%20martial%20arts%20drama%20poster%20elegant%20ancient%20Chinese%20landscape%20with%20lotus%20flowers%20soft%20mist%20traditional%20ink%20painting%20style%20serene%20atmosphere&width=600&height=800&seq=hot-rec-06&orientation=portrait',
    tags: ['经典'], link: '/category?tab=电视剧',
  },
];

export interface CategoryItem {
  id: string;
  name: string;
  icon: string;
  count: number;
  imageUrl: string;
  link: string;
}

export const categories: CategoryItem[] = [
  {
    id: 'cat-1', name: '电视剧', icon: 'ri-tv-line', count: 1280,
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20TV%20drama%20collection%20collage%20modern%20and%20historical%20costume%20dramas%20warm%20lighting%20elegant%20composition%20rich%20colors%20cinematic%20style%20soft%20gradient%20background&width=800&height=600&seq=cat-drama&orientation=landscape',
    link: '/category?tab=电视剧',
  },
  {
    id: 'cat-2', name: '电影', icon: 'ri-film-line', count: 3560,
    imageUrl: 'https://readdy.ai/api/search-image?query=Movie%20collection%20cinematic%20collage%20film%20reels%20and%20posters%20dramatic%20lighting%20dark%20theater%20atmosphere%20gold%20and%20crimson%20accents%20classic%20cinema%20aesthetic&width=800&height=600&seq=cat-movie&orientation=landscape',
    link: '/category?tab=电影',
  },
  {
    id: 'cat-3', name: '综艺', icon: 'ri-emotion-laugh-line', count: 890,
    imageUrl: 'https://readdy.ai/api/search-image?query=Variety%20show%20stage%20colorful%20lighting%20entertainment%20program%20set%20bright%20cheerful%20atmosphere%20dynamic%20composition%20vibrant%20neon%20colors%20modern%20TV%20studio%20background&width=800&height=600&seq=cat-variety&orientation=landscape',
    link: '/category?tab=综艺',
  },
  {
    id: 'cat-4', name: '动漫', icon: 'ri-rocket-line', count: 2150,
    imageUrl: 'https://readdy.ai/api/search-image?query=Anime%20style%20illustration%20collection%20vibrant%20Japanese%20animation%20art%20style%20colorful%20characters%20dynamic%20poses%20bright%20sky%20background%20soft%20pastel%20colors%20energetic%20composition&width=800&height=600&seq=cat-anime&orientation=landscape',
    link: '/category?tab=动漫',
  },
  {
    id: 'cat-5', name: '纪录片', icon: 'ri-earth-line', count: 670,
    imageUrl: 'https://readdy.ai/api/search-image?query=Documentary%20film%20collection%20nature%20and%20wildlife%20cinematography%20stunning%20landscapes%20aerial%20shots%20warm%20natural%20lighting%20professional%20documentary%20photography%20style%20rich%20earth%20tones&width=800&height=600&seq=cat-doc&orientation=landscape',
    link: '/category?tab=纪录片',
  },
  {
    id: 'cat-6', name: '少儿', icon: 'ri-heart-line', count: 430,
    imageUrl: 'https://readdy.ai/api/search-image?query=Children%20animation%20collection%20cute%20colorful%20cartoon%20style%20playful%20atmosphere%20soft%20pastel%20rainbow%20colors%20happy%20cheerful%20theme%20whimsical%20background%20with%20stars%20and%20clouds&width=800&height=600&seq=cat-kids&orientation=landscape',
    link: '/category?tab=少儿',
  },
];

export interface ArticleItem {
  id: string;
  title: string;
  summary: string;
  category: string;
  date: string;
  readTime: string;
  imageUrl: string;
  slug: string;
}

export const latestArticles: ArticleItem[] = [
  {
    id: 'article-1', title: '2026年暑期档热播剧推荐：这五部高分剧集不容错过',
    summary: '暑期档来了，我们为你精选了五部豆瓣评分8.5以上的热播剧集，从古装权谋到现代都市，总有一部适合你。',
    category: '推荐盘点', date: '2026-07-28', readTime: '8分钟',
    imageUrl: 'https://readdy.ai/api/search-image?query=Summer%20TV%20drama%20recommendation%20article%20cover%20bright%20summer%20vibes%20colorful%20TV%20screen%20displays%20warm%20sunlight%20modern%20living%20room%20cozy%20atmosphere%20editorial%20photography&width=800&height=450&seq=article-01&orientation=landscape',
    slug: 'summer-2026-hot-dramas',
  },
  {
    id: 'article-2', title: '茄子视频全新升级：更高清、更流畅的观影体验',
    summary: '茄子视频技术团队历时三个月完成了平台全面升级，带来4K超高清画质和智能缓冲技术。',
    category: '平台动态', date: '2026-07-25', readTime: '5分钟',
    imageUrl: 'https://readdy.ai/api/search-image?query=Video%20streaming%20platform%20upgrade%20announcement%20modern%20tech%20office%20with%20multiple%20screens%20displaying%204K%20content%20clean%20minimalist%20design%20professional%20atmosphere%20soft%20lighting&width=800&height=450&seq=article-02&orientation=landscape',
    slug: 'platform-upgrade-2026',
  },
  {
    id: 'article-3', title: '国产动画崛起：2026年最值得期待的国产动漫作品',
    summary: '从《哪吒》到《深海》，国产动画正在经历前所未有的黄金时代。盘点2026年最值得期待的动画新作。',
    category: '动漫资讯', date: '2026-07-20', readTime: '6分钟',
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20animation%20rising%20trend%20article%20cover%20beautiful%20Chinese%20style%20animation%20art%20ink%20painting%20style%20mixed%20with%203D%20modern%20elements%20vibrant%20colors%20artistic%20composition&width=800&height=450&seq=article-03&orientation=landscape',
    slug: 'chinese-anime-rising-2026',
  },
];

export const faqItems = [
  {
    question: '茄子视频是否需要注册才能观看？',
    answer: '不需要。茄子视频完全免费，无需注册即可在线观看所有内容，真正做到即点即看。',
  },
  {
    question: '视频播放卡顿怎么办？',
    answer: '茄子视频采用智能缓冲技术，可根据您的网络状况自动调整清晰度。如遇卡顿，建议尝试切换至较低清晰度，或检查您的网络连接。',
  },
  {
    question: '支持哪些设备观看？',
    answer: '茄子视频支持电脑、平板、手机等所有主流设备观看，无需安装任何插件或APP，打开浏览器即可畅享高清影视。',
  },
  {
    question: '视频资源多久更新一次？',
    answer: '我们的内容团队每天更新影视资源，热播剧集一般在播出后2小时内上线，确保您不错过任何精彩内容。',
  },
  {
    question: '能否下载视频离线观看？',
    answer: '目前茄子视频为在线观看平台，暂不支持下载功能。但我们支持断点续播，您可以随时继续上次观看的进度。',
  },
  {
    question: '遇到播放问题如何反馈？',
    answer: '您可以通过关于我们页面的联系方式与我们取得联系，我们的客服团队会在24小时内回复您的问题。',
  },
];

export const platformStats = [
  { label: '影视资源', value: '10,000+', icon: 'ri-movie-line' },
  { label: '每日更新', value: '200+', icon: 'ri-refresh-line' },
  { label: '日均用户', value: '500万+', icon: 'ri-user-line' },
  { label: '高清画质', value: '4K', icon: 'ri-4k-line' },
];